<template>

</template>

<script>
export default {
  name: "Source_ofsupply",
  data() {
    return {
      
    };
  },
  mounted() {},
  created() {},
  methods: {

  }
};
</script>

<style lang="scss" scoped>

</style>